import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getFixedDepositRequests: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_FIXED_DEPOSIT_REQUESTS_START,
    payload: params,
  }),
  getFixedDepositRequestsSuccess: (data: any) => ({
    type: actionTypes.GET_FIXED_DEPOSIT_REQUESTS_SUCCESS,
    payload: data,
  }),
  getFixedDepositRequestsFinish: () => ({
    type: actionTypes.GET_FIXED_DEPOSIT_REQUESTS_FINISH,
  }),
}
